// Environment variable validation utility
export const validateEnvironment = () => {
  const requiredEnvVars = {
    'REACT_APP_BASE_URL': process.env.REACT_APP_BASE_URL,
    'REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID': process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    'REACT_APP_POSTHOG_KEY': process.env.REACT_APP_POSTHOG_KEY,
    'REACT_APP_POSTHOG_HOST': process.env.REACT_APP_POSTHOG_HOST,
    'REACT_APP_GOOGLE_MAPS_API_KEY': process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  };

  const optionalEnvVars = {
    'REACT_APP_URL_IMAGE': process.env.REACT_APP_URL_IMAGE,
    'REACT_APP_ADMIN_API_URL': process.env.REACT_APP_ADMIN_API_URL,
    'REACT_APP_VERSION': process.env.REACT_APP_VERSION
  };

  console.group('🔍 Environment Variables Check');
  console.log('Build Time:', new Date().toISOString());
  console.log('Node Environment:', process.env.NODE_ENV);
  console.log('Public URL:', process.env.PUBLIC_URL);
  
  console.group('✅ Required Variables:');
  Object.entries(requiredEnvVars).forEach(([key, value]) => {
    const status = value ? '✅' : '❌ MISSING';
    const displayValue = value ? (key.includes('KEY') ? '[REDACTED]' : value) : 'undefined';
    console.log(`${status} ${key}: ${displayValue}`);
  });
  console.groupEnd();

  console.group('ℹ️ Optional Variables:');
  Object.entries(optionalEnvVars).forEach(([key, value]) => {
    const status = value ? '✅' : '⚠️ Not Set';
    const displayValue = value ? (key.includes('KEY') ? '[REDACTED]' : value) : 'undefined';
    console.log(`${status} ${key}: ${displayValue}`);
  });
  console.groupEnd();

  const missingRequired = Object.entries(requiredEnvVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingRequired.length > 0) {
    console.error('❌ Missing required environment variables:', missingRequired);
    console.error('This may cause the app to fail or behave unexpectedly');
    
    // Show user-friendly error in development
    if (process.env.NODE_ENV === 'development') {
      alert(`Missing environment variables: ${missingRequired.join(', ')}`);
    }
  } else {
    console.log('✅ All required environment variables are set');
  }

  console.groupEnd();
  return { missing: missingRequired, valid: missingRequired.length === 0 };
};

export const logAppInfo = () => {
  console.group('📱 Rally App Debug Info');
  console.log('App Name:', process.env.REACT_APP_NAME || 'Rally App');
  console.log('Version:', process.env.REACT_APP_VERSION || 'Unknown');
  console.log('Build Date:', process.env.REACT_APP_BUILD_DATE || new Date().toISOString());
  console.log('User Agent:', navigator.userAgent);
  console.log('Screen Size:', `${window.screen.width}x${window.screen.height}`);
  console.log('Viewport Size:', `${window.innerWidth}x${window.innerHeight}`);
  console.log('URL:', window.location.href);
  console.log('Referrer:', document.referrer || 'Direct');
  console.log('Local Storage Available:', typeof(Storage) !== 'undefined');
  console.log('Service Worker Supported:', 'serviceWorker' in navigator);
  console.groupEnd();
};